import { render, staticRenderFns } from "./PanelAccountSettingsAgreements.vue?vue&type=template&id=4b6bd107&scoped=true&"
import script from "./PanelAccountSettingsAgreements.vue?vue&type=script&lang=js&"
export * from "./PanelAccountSettingsAgreements.vue?vue&type=script&lang=js&"
import style0 from "./PanelAccountSettingsAgreements.vue?vue&type=style&index=0&id=4b6bd107&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6bd107",
  null
  
)

export default component.exports